import { listen, qsa, qs, toggle, contains } from '@fluorescent/dom';
import { focusFormStatus } from '@/lib/a11y';

import { section } from '@/glow';
import { wrapIframes, wrapTables } from '@/lib/rte';

section('article', {
  onLoad() {
    focusFormStatus(this.container);
    const socialButtons = qsa('[data-social-share]', this.container);

    this.events = [
      listen(socialButtons, 'click', e => {
        toggle(e.target, 'active');
        const sub = qs('.article__share-icons', e.target);

        sub.setAttribute('aria-hidden', !contains(e.target, 'active'));
      }),
    ];

    wrapIframes(qsa('iframe', this.container));
    wrapTables(qsa('table', this.container));
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
  },
});
